import React from 'react';
import './Contact.css';

function Contact() {
    function openGmail(event) {
        // Previene el comportamiento por defecto
        event.preventDefault();
    
        const email = "pojobox.3d@gmail.com";
        const subject = encodeURIComponent("Solicitud de Información");
        const body = encodeURIComponent("Hola, estoy interesado/a en tus servicios. ¿Podrías darme más información?");
        const mailtoURL = `mailto:${email}?subject=${subject}&body=${body}`;
    
        // Abre el esquema mailto
        window.location.href = mailtoURL;
    }
    
    
    return (
        <div className="contact-container">
            <h1>CONTACTO</h1>
            <p>Si no encuentras lo que buscas o necesitas algo más personalizado, no dudes en contactarnos. Estaremos encantados de ofrecerte una solución a medida y un presupuesto personalizado para tus necesidades.</p>
            <div className="media-contact">
                <p>Medios de contacto disponibles:</p>

                <ul className="contact-links">
                    <li>
                        <a
                            href="https://wa.me/message/FP7HWEHLWLHMJ1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp-link"
                        >
                            <i className="fab fa-whatsapp"></i> WhatsApp (solo mensaje)
                        </a>
                    </li>
                    <li>
                        <a
                            href="#"
                            className="email-link"
                            id="email-link"
                            onClick={openGmail} // Usa onClick para React
                        >
                            <i className="fas fa-envelope"></i> Correo Electrónico
                        </a>
                    </li>

                    <li>
                        <a
                            href="https://www.instagram.com/pojobox3d/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="instagram-link"
                        >
                            <i className="fab fa-instagram"></i> Instagram
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Contact;
